import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { interpretMetadata, contentfulMetadataPropType } from '@glowforge/ui-common/models';
import { PageMetadata } from '@glowforge/ui-common/components/contentful-views';
import { pagePropType } from '../prop-types/contentful';

/**
 * The `Page` component in ui-common does not include page metadata for pages
 * with type `custom`. Usually we want custom pages to have their own metadata
 * that inherits from the default page metadata. In order to do this, we can
 * explicitly include the `PageMetadata` component in custom pages we create.
 */
const CustomPageMetadata = ({ page, metadata, stringSubstitutions }) => {
  let meta;

  if (page) {
    meta = _.get(page, 'fields.pageMetadata', {});
  } else {
    meta = metadata;
  }

  if (!meta) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PageMetadata {...interpretMetadata(meta, stringSubstitutions)} />
  );
};

CustomPageMetadata.propTypes = {
  page: pagePropType,
  metadata: PropTypes.shape(contentfulMetadataPropType),
  stringSubstitutions: PropTypes.objectOf(PropTypes.string),
};

CustomPageMetadata.defaultProps = {
  page: null,
  metadata: null,
  stringSubstitutions: {},
};

export default CustomPageMetadata;
